import { Spinner } from "react-bootstrap";

export default function FinishButton({ unitaryLoadSelected, handleSave, lockNextBtn }) {
	return (
		<button className="btn btn-primary float-right" onClick={handleSave} disabled={lockNextBtn}>
			{lockNextBtn && <Spinner style={{ width: "4rem", height: "4rem" }} className="spinner-loading" animation="border" size="" />}
			{unitaryLoadSelected ? "Guardar productos" : "Finalizar"}
		</button>
	);
}
